class LQCountdown extends HTMLElement {
  constructor() {
    super();

    this.arrival_date = this.dataset.endDate;
    this.countDownDate = new Date(`${this.arrival_date} GMT`).getTime();
    this.grid = this.querySelector('.grid');
    this.days = this.querySelector('.count_down_days');
    this.hours = this.querySelector('.count_down_hours');
    this.minutes = this.querySelector('.count_down_minutes');
    this.seconds = this.querySelector('.count_down_seconds');

  }
  connectedCallback() {
    this.timerID = setInterval(() => {
      this.countDownInterval();
    }, 1000);

    setTimeout(() => {
      this.classList.remove("hidden");
    }, 1000);
  }

  countDownInterval() {
    let now = new Date().getTime();
    let distance = this.countDownDate - now;

    if (distance >= 0) {
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.setInnerText(this.days, days);
      this.setInnerText(this.hours, hours);
      this.setInnerText(this.minutes, minutes);
      this.setInnerText(this.seconds, seconds);

    } else if (distance >= -1000) {
      location.reload();
    } else {
      clearInterval(this.timerID);
      this.grid.classList.add("hidden");
      if (this.querySelector('.countdown_end_message')) {
        this.querySelector('.countdown_end_message').classList.remove("hidden");
      }
    }
  }

  setInnerText = (element, value) => {
    if (value < 10) {
      value = "0" + value;
    }
    element.innerText = value;
  }

}

customElements.define('lq-countdown', LQCountdown);